<template>
  <div>
    <v-dialog v-model="isOpen" transition="dialog-left-transition" scrollable fullscreen eager>
      <template #activator="{ on, attrs }">
        <v-btn
          :class="$style['serial-number']"
          class="px-2"
          v-bind="attrs"
          elevation="0"
          text
          v-on="on"
        >
          <IconSelect class="mr-2" icon="SerialNumber" height="20" width="24" />{{
            $t('filter.sparePartsFinder.serialNumberAbbreviation')
          }}
        </v-btn>
      </template>
      <v-card>
        <v-toolbar :class="$style.toolbar">
          <v-btn class="px-2" elevation="0" text @click="isOpen = !isOpen">
            <IconSelect class="mr-1" icon="close" height="40" width="40" />{{ $t('filter.show') }}
          </v-btn>
          <v-spacer />
          <MobileFilterCount />
        </v-toolbar>
        <v-card-text class="py-8">
          <SparePartsFinder :class="$style['spare-parts-finder']" @close="isOpen = !isOpen" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import IconSelect from '@/js/components/Shared/IconSelect/IconSelect.vue'
import MobileFilterCount from '@/js/components/ContentElement/Catalog/mobile/MobileFilterCount'
import SparePartsFinder from '@/js/components/ContentElement/ProductFilter/SpareParts/SparePartsFinder'
export default {
  name: 'MobileSparePartsFinder',
  components: {
    IconSelect,
    MobileFilterCount,
    SparePartsFinder,
  },
  data() {
    return {
      isOpen: false,
      topGap: 50,
    }
  },
  watch: {
    isOpen() {
      document.querySelector('html').classList.toggle('overflow-y-hidden')
    },
  },
}
</script>

<style lang="scss" module>
.toolbar :global(.v-toolbar__content) {
  padding: 0;
}

.toolbar {
  max-height: 56px;
}

.serial-number {
  @media screen and (min-width: map-get($grid-breakpoints, 'md')) {
    font-size: 1.25rem;
  }
  font-size: 0.7rem !important;
}

.spare-parts-finder {
  max-width: 100% !important;
}
</style>
